function e(r) {
  return Number.isNaN(+r) ? 0 : +r;
}
export {
  e as trimZeroPrefix
};
